import { Component } from '@angular/core';

import { GlobalState } from '../../../global.state';
import { Location } from '@angular/common';
import { debug } from 'util';

declare var $: any;

@Component({
  selector: 'ubi-content-top',
  styleUrls: ['./ubiContentTop.scss'],
  templateUrl: './ubiContentTop.html',
})
export class UbiContentTop {

  private showBackButton = false;

  constructor(private _state: GlobalState, private _location: Location) {
    this._state.subscribe('menu.activeLink', (activeLink) => {
      if (activeLink) {
        $('.content-top .al-title').text(activeLink.title);
        // Clear movements count in the top bar
        $('.content-top .movements-count').text('');
        $('.content-top .total-movements-count').text('');        
      }
    });

    this._state.subscribe('backButton.changeState', (visible) => {
      this.showBackButton = visible;
    });
  }

  onBackButtonClick() {
    this._location.back();
  }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiContentTop/ubiContentTop.component.ts